import React from 'react';
import {
  Html,
  Head,
  Body,
  Container,
  Section,
  Text,
  Link,
  Hr,
  Preview,
  Font,
} from '@react-email/components';

export interface LayoutTranslations {
  headerSubtitle: string;
  footerTitle: string;
  footerLocation: string;
  footerUnsubscribe: string;
}

interface LayoutProps {
  previewText?: string;
  children: React.ReactNode;
  translations: LayoutTranslations;
}

const baseUrl = 'https://siportevent.com';

export default function Layout({ previewText, children, translations: tx }: LayoutProps) {
  return (
    <Html lang="fr">
      <Head>
        <Font
          fontFamily="Inter"
          fallbackFontFamily="Helvetica"
          webFont={{
            url: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap',
            format: 'woff2',
          }}
        />
      </Head>
      {previewText && <Preview>{previewText}</Preview>}
      <Body style={body}>
        <Container style={container}>
          <Section style={header}>
            <Link href={baseUrl} style={logo}>
              SIPORT 2026
            </Link>
            <Text style={subtitle}>{tx.headerSubtitle}</Text>
          </Section>

          <Section style={content}>{children}</Section>

          <Section style={footer}>
            <Text style={socialLinks}>
              <Link href="https://www.facebook.com/people/Siports/61587046582233/" style={socialLink}>
                Facebook
              </Link>
              {' | '}
              <Link href="https://www.instagram.com/siports_/" style={socialLink}>
                Instagram
              </Link>
              {' | '}
              <Link href="https://ma.linkedin.com/company/siport-event" style={socialLink}>
                LinkedIn
              </Link>
            </Text>
            <Hr style={divider} />
            <Text style={footerText}>
              {tx.footerTitle}
              <br />
              {tx.footerLocation}
            </Text>
            <Text style={unsubscribeText}>{tx.footerUnsubscribe}</Text>
          </Section>
        </Container>
      </Body>
    </Html>
  );
}

const body: React.CSSProperties = {
  backgroundColor: '#f3f4f6',
  margin: 0,
  padding: '20px 0',
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
};

const container: React.CSSProperties = {
  maxWidth: '600px',
  margin: '0 auto',
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  overflow: 'hidden',
};

const header: React.CSSProperties = {
  background: 'linear-gradient(135deg, #1e3a5f 0%, #2563eb 50%, #0ea5e9 100%)',
  padding: '40px 20px',
  textAlign: 'center' as const,
};

const logo: React.CSSProperties = {
  fontSize: '32px',
  fontWeight: 700,
  color: '#ffffff',
  textDecoration: 'none',
};

const subtitle: React.CSSProperties = {
  color: '#bfdbfe',
  margin: '10px 0 0 0',
  fontSize: '16px',
};

const content: React.CSSProperties = {
  padding: '40px 30px',
  color: '#1f2937',
  lineHeight: '1.6',
};

const footer: React.CSSProperties = {
  backgroundColor: '#1e293b',
  padding: '30px 20px',
  textAlign: 'center' as const,
};

const socialLinks: React.CSSProperties = {
  margin: '0 0 10px 0',
  fontSize: '14px',
};

const socialLink: React.CSSProperties = {
  color: '#60a5fa',
  textDecoration: 'none',
};

const divider: React.CSSProperties = {
  borderColor: '#334155',
  margin: '15px 0',
};

const footerText: React.CSSProperties = {
  color: '#94a3b8',
  fontSize: '13px',
  margin: '0 0 10px 0',
};

const unsubscribeText: React.CSSProperties = {
  color: '#64748b',
  fontSize: '12px',
  margin: 0,
};
